import { BookingCancelResponse } from "@/models/api/BookingCancelResponse";
import { BookingResponse } from "@/models/api/BookingResponse";
import { UnloadBookingResponse } from "@/models/api/UnloadBookingResponse";
import { ConfirmationEmailRequest } from "@/models/api/ConfirmationEmailRequest";
import { Booking } from "@/models/www/Booking";
import { BookingCancel } from "@/models/www/BookingCancel";
import baseApi from "./api.service";

const bookingService = {
	getBooking(bookingReference: string): Promise<Booking> {
		return new Promise((resolve, reject) => {
			baseApi.get<BookingResponse>(`booking/${bookingReference}`)
				.then(resp => resolve(new Booking(resp)))
				.catch(err => reject(err))
		})
	},
	sendConfirmationMail(req: ConfirmationEmailRequest): Promise<any> {
		return new Promise((resolve, reject) => {
			baseApi.post<any>("mail/confirmation", req)
				.then(resp => resolve(resp))
				.catch(err => reject(err))
		})
	},
	sendAgentMailCopy(req: ConfirmationEmailRequest): Promise<any> {
		return new Promise((resolve, reject) => {
			baseApi.post<any>("agent/confirmation/copy", req)
				.then(resp => resolve(resp))
				.catch(err => reject(err))
		})
	},
	unloadBookings(): Promise<UnloadBookingResponse> {
		return new Promise((resolve, reject) => {
			baseApi.post<UnloadBookingResponse>('booking/unload', {})
				.then(resp => resolve(resp))
				.catch(err => reject(err))
		})
	},
	prepareBookingCancellation(bookingReference: string): Promise<BookingCancel> {
		return new Promise((resolve, reject) => {
			baseApi.post<BookingCancelResponse>(`booking/cancel/prepare/${bookingReference}`, {})
				.then(resp => resolve(new BookingCancel(resp)))
				.catch(err => reject(err))
		})
	},
	prepareDepartureCancellation(route: string, bookingReference: string): Promise<BookingCancel> {
		return new Promise((resolve, reject) => {
			baseApi.post<BookingCancelResponse>(`booking/cancel/prepare/${route}/${bookingReference}`, {})
				.then(resp => resolve(new BookingCancel(resp)))
				.catch(err => reject(err))
		})
	},
	cancelDeparture(route: string, bookingReference: string): Promise<BookingCancel> {
		return new Promise((resolve, reject) => {
			baseApi.post<BookingCancelResponse>(`booking/cancel/${route}/${bookingReference}`, {})
				.then(resp => resolve(new BookingCancel(resp)))
				.catch(err => reject(err))
		})
	},
	cancelBooking(bookingReference: string): Promise<BookingCancel> {
		return new Promise((resolve, reject) => {
			baseApi.post<BookingCancelResponse>(`booking/cancel/${bookingReference}`, {})
				.then(resp => resolve(new BookingCancel(resp)))
				.catch(err => reject(err))
		})
	},
}

export default bookingService;